/**
 * L17 (AN-12 §5.4): arquivo expurgado responde `410 DOCUMENTO_EXPURGADO` em `/arquivo`,
 * `/download`, `/conteudo`, `/analise` e `versoes/{id}/arquivo` — nunca 500 do MinIO.
 * Em download o corpo é Blob (o `errorCode` não é legível), então o status basta.
 *
 * Módulo próprio (fora do `documentoService`) para que os testes que fazem mock do serviço
 * não precisem repetir esta função.
 */
export const MENSAGEM_DOCUMENTO_EXPURGADO = 'Arquivo expurgado — não está mais disponível.'

export const ehDocumentoExpurgado = (e: unknown): boolean => {
  const falha = e as { status?: number; data?: { errorCode?: unknown } } | null
  return falha?.status === 410 || falha?.data?.errorCode === 'DOCUMENTO_EXPURGADO'
}
